import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Storage } from "@/common/utils/storage";
import {
  PUSH_PERMISSION_STATUS_QUERY_KEY,
  PushNotificationService,
} from "@/common/utils/PushNotificationService";
import { PushNotificationsPrompt } from "@/components/PushNotifications/PushNotificationsPrompt";
import { NotificationAudience } from "@/components/PushNotifications/notification-audience";

const DISMISSED_STORAGE_KEY = "orgNotificationsDismissed";
const DISMISSED_QUERY_KEY = ["orgNotificationsDismissed"];
const DISMISS_DURATION_MS = 30 * 24 * 60 * 60 * 1000;

async function isDismissed() {
  const dismissedAt = await Storage.getItem(DISMISSED_STORAGE_KEY);
  if (!dismissedAt) {
    return false;
  }

  const dismissedAtMs = Number(dismissedAt);
  return (
    Number.isFinite(dismissedAtMs) &&
    Date.now() - dismissedAtMs < DISMISS_DURATION_MS
  );
}

export function OrgHomePushBanner() {
  const queryClient = useQueryClient();
  const { data: status } = useQuery({
    queryKey: PUSH_PERMISSION_STATUS_QUERY_KEY,
    queryFn: () => PushNotificationService.checkPermissionStatus(),
    refetchOnMount: "always",
  });
  const { data: dismissed, isLoading: isDismissedLoading } = useQuery({
    queryKey: DISMISSED_QUERY_KEY,
    queryFn: isDismissed,
    refetchOnMount: "always",
  });

  const dismiss = async () => {
    await Storage.setItem(DISMISSED_STORAGE_KEY, String(Date.now()));
    queryClient.setQueryData(DISMISSED_QUERY_KEY, true);
  };

  if (
    isDismissedLoading ||
    dismissed ||
    !status ||
    status.receive === "granted"
  ) {
    return null;
  }

  return (
    <div className="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm">
      <PushNotificationsPrompt
        onComplete={dismiss}
        showHeading
        title="Stay in the loop"
        audience={NotificationAudience.Organization}
      />
    </div>
  );
}
